import { Clerk } from '@clerk/clerk-js/headless';

import { hasWindow } from 'utils/browser.utils';

const clerk = new Clerk(process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY!);

/** REST API auth: Clerk JWT when signed in; ApiKey on SSR or logged-out. */
export const getApiAuthorizationHeader = async (): Promise<string> => {
  if (!hasWindow()) {
    return `ApiKey ${process.env.NEXT_PUBLIC_API_KEY}`;
  }

  if (!clerk.loaded) await clerk.load({ telemetry: false });

  const token = await clerk.session?.getToken();
  return token
    ? `Bearer ${token}`
    : `ApiKey ${process.env.NEXT_PUBLIC_API_KEY}`;
};
